import { BORDER_COLORS as BC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import { FONT_FAMILY } from '@constants/fonts.ts';
import { BODY_XS_XS_MEDIUM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const PageHeader = styled.div`
    color: ${TC.heading};
    ${DESKTOP_SIZES[SIZES.HEADING_LG].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_LG].lineHeight};
    ${DESKTOP_SIZES[SIZES.HEADING_LG].fontWeight};
`;

export const PageHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const EditAvatar = styled.div`
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: pointer;

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const SubmitForApproval = styled.div`
    display: flex;
    gap: 16px;
`;

export const TabContent = styled.div<{ $marginBottom?: number; $width?: string }>`
    padding: 24px;
    border: 1px solid ${BC.primary};
    border-radius: 8px;
    ${FONT_FAMILY.poppins};

    ${({ $marginBottom }) => $marginBottom && `margin-bottom: ${$marginBottom}px;`}
    ${({ $width }) => $width && `width: ${$width};`}
`;

export const AvatarEditedText = styled.div`
    ${BODY_XS_XS_MEDIUM_STYLES};
    color: var(--colors-text-headings, #3e445c);
    position: absolute;
    left: 16px;
    margin-top: -4px;
`;

// TODO: temporarily hidden (BBL-2626)
export const EditProfileButtonWrapper = styled.div`
    display: none;
`;
